import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { pcmpUrgentBatchReportQueryOptions } from '../api/pcmpUrgent.api';
import { PcmpBatchPrintView } from '../components/PcmpBatchReport/PcmpBatchPrintView';

export function PcmpUrgentBatchPrintPage() {
  const { batchNo } = useParams({ from: '/_print/pcmp/requests/batches/$batchNo/print' });
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    ...pcmpUrgentBatchReportQueryOptions(batchNo),
    // Closing the print dialog refocuses the tab; keep the sheet as printed.
    refetchOnWindowFocus: false,
  });

  return (
    <PcmpBatchPrintView
      batchNo={batchNo}
      report={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={() => void refetch()}
      documentTitle={`CMP Urgent Batch ${batchNo}`}
    />
  );
}
